import { Link } from "@tanstack/react-router";
import { LogoHorizontal } from "@/components/brand/LogoHorizontal";
import { SearchInput } from "@/components/ui/SearchInput";
import { ViewerMenu } from "./ViewerMenu";

const NAV_LINKS = [
  { label: "Marketplace", to: "/marketplace" },
  { label: "Communities", to: "/communities" },
  { label: "Creators", to: "/explore" },
  { label: "Jobs", to: "/jobs" },
] as const;

/** Marketing top nav — DESIGN.md §8.2 landing composition. */
export function MarketingHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-surface-1/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-(--breakpoint-xl) items-center gap-6 px-4 sm:px-6 lg:px-8">
        <Link to="/" aria-label="Studside home" className="shrink-0">
          <LogoHorizontal />
        </Link>
        <nav className="hidden items-center gap-6 md:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="text-small font-medium text-text-secondary transition-colors hover:text-text-primary"
              activeProps={{ className: "text-text-primary!" }}
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <SearchInput className="hidden lg:block" containerClassName="ml-auto hidden max-w-64 lg:flex" />
        <div className="ml-auto flex items-center gap-2 lg:ml-4">
          <ViewerMenu size="md" />
        </div>
      </div>
    </header>
  );
}
